import Evenementen from './Evenementen';
export default Evenementen;